import {h, type FunctionalComponent} from '@stencil/core';
import type {IDashboardDesktopView} from '../dashboard-desktop-view';

interface ConversationalBannerProps extends Pick<IDashboardDesktopView,
  'country' | 'language' | 'query' | 'isConversationalSearchActive' | 'conversationalSearchProductsEndpoint' | 'apigeeAuth' | 'apigeeTokenUrl' | 'labelProvider' | 'conversationalSearchBrandUrl' | 'conversationalSearchMedaliaFormId' | 'dynamicBannerActiveByDefault'> {
  isVisible: boolean;
}

export const ConversationalBanner:FunctionalComponent<ConversationalBannerProps> = (props) => {
    const {
      country,
      language,
      query,
      isConversationalSearchActive,
      conversationalSearchProductsEndpoint,
      apigeeAuth,
      apigeeTokenUrl,
      conversationalSearchBrandUrl,
      conversationalSearchMedaliaFormId,
      labelProvider,
      isVisible,
      dynamicBannerActiveByDefault
    } = props;
    return isConversationalSearchActive && isVisible ? (
      <div class={{'conversational-dynamic-banner--active-by-default': dynamicBannerActiveByDefault}}>
        <uiaas-search-widget-conversational-search-banner-mediator
          country={country}
          language={language}
          labelProvider={(e, f) => labelProvider(e, f)}
          conversationalSearchProductsEndpoint={conversationalSearchProductsEndpoint}
          query={query}
          apigeeAuth={apigeeAuth}
          apigeeTokenUrl={apigeeTokenUrl}
          conversationalSearchBrandUrl={conversationalSearchBrandUrl}
          conversationalSearchMedaliaFormId={conversationalSearchMedaliaFormId}
          dynamicBannerActiveByDefault={dynamicBannerActiveByDefault}
        />
      </div>

    ) : '';
};

export default ConversationalBanner;
